"use client";

import { c as _c } from "react/compiler-runtime";
import type { ChangeEvent } from "react";
import { parsePositiveWholeNumberInput } from "../utils/positiveWholeNumberInput";
export default function CreateWaveApprovalMaxWinners(t0) {
  const $ = _c(17);
  const {
    maxWinners,
    setMaxWinners
  } = t0;
  let t1;
  if ($[0] !== setMaxWinners) {
    t1 = e => {
      setMaxWinners(parsePositiveWholeNumberInput(e.target.value));
    };
    $[0] = setMaxWinners;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onMaxWinnersChange = t1;
  let t2;
  if ($[2] !== maxWinners) {
    t2 = maxWinners !== null && Number.isInteger(maxWinners) && maxWinners > 0;
    $[2] = maxWinners;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const hasMaxWinners = t2;
  let t3;
  if ($[4] !== hasMaxWinners || $[5] !== maxWinners) {
    t3 = hasMaxWinners ? maxWinners.toString() : "";
    $[4] = hasMaxWinners;
    $[5] = maxWinners;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = `${hasMaxWinners ? "tw-text-primary-400 focus:tw-text-white" : "tw-text-white"} tw-peer tw-form-input tw-block tw-w-full tw-appearance-none tw-rounded-lg tw-border-0 tw-border-iron-600 tw-bg-iron-900 tw-px-4 tw-pb-3 tw-pt-4 tw-text-base tw-font-medium tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-650 tw-transition tw-duration-300 tw-ease-out placeholder:tw-text-iron-500 focus:tw-border-blue-500 focus:tw-bg-iron-900 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 sm:tw-text-sm`;
  let t5;
  if ($[7] !== onMaxWinnersChange || $[8] !== t3 || $[9] !== t4) {
    t5 = <input type="text" inputMode="numeric" value={t3} onChange={onMaxWinnersChange} id="approval-max-winners" autoComplete="off" className={t4} placeholder=" " />;
    $[7] = onMaxWinnersChange;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <label htmlFor="approval-max-winners" className="tw-absolute tw-start-1 tw-top-2 tw-z-10 tw-origin-[0] -tw-translate-y-4 tw-scale-75 tw-transform tw-cursor-text tw-bg-iron-900 tw-px-2 tw-text-base tw-font-normal tw-text-iron-500 tw-duration-300 peer-placeholder-shown:tw-top-1/2 peer-placeholder-shown:-tw-translate-y-1/2 peer-placeholder-shown:tw-scale-100 peer-focus:tw-top-2 peer-focus:-tw-translate-y-4 peer-focus:tw-scale-75 peer-focus:tw-bg-iron-900 peer-focus:tw-px-2 peer-focus:tw-text-primary-400 rtl:peer-focus:tw-left-auto rtl:peer-focus:tw-translate-x-1/4">Max Winners (optional)</label>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5) {
    t7 = <div className="tw-group tw-relative tw-w-full">{t5}{t6}</div>;
    $[12] = t5;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <p className="tw-mb-0 tw-mt-2 tw-text-xs tw-text-iron-400">Leave blank for unlimited winners.</p>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7) {
    t9 = <div className="tw-w-full">{t7}{t8}</div>;
    $[15] = t7;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}